"use client";

import { Facebook, Instagram, Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-5 w-24 bg-muted/40 animate-pulse rounded-md" />
        <div className="h-5 w-20 bg-muted/40 animate-pulse rounded-md" />
        <div className="h-5 w-28 bg-muted/40 animate-pulse rounded-md" />
        <div className="h-5 w-24 bg-muted/40 animate-pulse rounded-md" />
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground font-default text-[0.9375rem] font-medium inline-flex items-center group">
            <span className="relative">
              {item.label}
              <span className="absolute left-0 -bottom-0.5 h-[1.5px] w-0 bg-primary transition-all duration-200 group-hover:w-full group-hover:h-[3px]" />
            </span>
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const tickerItems = ["roof inspections", "storm damage repair", "cash home buying", "nationwide solutions"];
  const tickerLoop = [...tickerItems, ...tickerItems, ...tickerItems];
  const mascots = [{
    name: "Roofing",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/roofing_service_icon.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/roofing_service_icon.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/roofing_service_icon.png-wvc-sizes",
    alt: "Professional roofing services icon"
  }, {
    name: "Construction",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/construction_quality_icon.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/construction_quality_icon.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/construction_quality_icon.png-wvc-sizes",
    alt: "Quality construction icon"
  }, {
    name: "RealEstate",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/real_estate_cash_icon.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/real_estate_cash_icon.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716391/img/real_estate_cash_icon.png-wvc-sizes",
    alt: "Fast cash home buying icon"
  }];
  return <section data-section-id="1510" id="footer" className="bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 right-0 h-px bg-border" />

      {}
      <div className="pointer-events-none absolute -top-32 -right-20 w-[28rem] h-[28rem] rounded-lg opacity-10 blur-3xl bg-primary" aria-hidden="true" />
      <div className="pointer-events-none absolute -bottom-40 -left-24 w-[32rem] h-[32rem] rounded-lg opacity-5 blur-3xl bg-primary" aria-hidden="true" />

      <div className="relative max-w-[1320px] mx-auto px-5 md:px-8 py-20">
        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {}
          <div className="md:col-span-5">
            <Link to="/HomePage" className="inline-block group">
              <h2 className="font-default text-4xl md:text-[2.25rem] font-semibold leading-[1.05] tracking-tight text-foreground">
                Luxury
                <span className="inline-block mx-2 align-middle text-2xl text-primary" aria-hidden="true">
                  
                </span>
                <span className="font-light">Construction</span>
              </h2>
            </Link>
            <p className="mt-5 font-default text-[0.8125rem] tracking-[0.04em] leading-[1.6] max-w-sm text-muted-foreground">
              Professional roofing services and nationwide cash home buying solutions —
              <br />
              established 2023
            </p>

            {}
            <div className="mt-8 font-default text-[0.6875rem] uppercase tracking-[0.18em] font-medium text-muted-foreground">
              §  license no. 2023 — certified
            </div>
          </div>

          {}
          <div className="md:col-span-3">
            <div className="font-default text-[0.6875rem] uppercase tracking-[0.18em] font-medium mb-5 text-muted-foreground">
              §  navigation
            </div>
            <MenuProvider menu_id="17">
              <FooterNavConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-4">
            <div className="font-default text-[0.6875rem] uppercase tracking-[0.18em] font-medium mb-5 text-muted-foreground">
              §  our expertise
            </div>

            {}
            <div className="flex items-end gap-3 mb-3">
              {mascots.map((m, i) => <div key={m.name} data-index={i} className="w-20 h-20 rounded-lg overflow-hidden flex items-center justify-center border border-border">
                  <img src={m.src} data-wvc-srcset={m.srcset} data-wvc-sizes={m.sizes} alt={m.alt} loading="lazy" decoding="async" className="w-full h-full object-cover" />
                </div>)}
            </div>

            <p className="font-default text-[0.75rem] italic tracking-[0.04em] mb-6 text-muted-foreground">
              <span className="text-primary"></span> trusted by homeowners nationwide
            </p>

            {}
            <div className="flex items-center gap-3">
              <Link to="#" aria-label="Instagram" className="w-9 h-9 rounded-lg inline-flex items-center justify-center transition-colors duration-240 bg-secondary text-primary">
                <Instagram className="w-4 h-4" />
              </Link>
              <Link to="#" aria-label="Facebook" className="w-9 h-9 rounded-lg inline-flex items-center justify-center transition-colors duration-240 bg-secondary text-primary">
                <Facebook className="w-4 h-4" />
              </Link>
              <Link to="#" aria-label="Yelp" className="w-9 h-9 rounded-lg inline-flex items-center justify-center transition-colors duration-240 bg-secondary text-primary">
                <Star className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 group/ticker overflow-hidden py-3 rounded-lg bg-secondary/50">
          <div className="flex whitespace-nowrap animate-[marquee_60s_linear_infinite] group-hover/ticker:[animation-play-state:paused]" style={{
          animation: "marquee 60s linear infinite"
        }}>
            {tickerLoop.map((item, i) => <div key={i} data-index={i} className="flex items-center font-default text-[0.8125rem] tracking-[0.16em] uppercase shrink-0 text-muted-foreground">
                <span className="mx-6 text-primary">
                  
                </span>
                <span>{item}</span>
              </div>)}
          </div>
        </div>

        {}
        <div className="mt-8 mb-6">
          <div className="w-full h-px border-t border-dashed border-border" />
        </div>

        {}
        <div className="text-center">
          <p className="font-default text-[0.75rem] tracking-[0.04em] text-muted-foreground">
            © 2025 Luxury Construction LLC · professional roofing & real estate solutions
          </p>
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
      `}</style>
    </section>;
}